import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem, CircularProgress } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogViatura = ({ viaturas, onClose, ...props }) => {
    const [loading, setLoading] = useState(false);
    const form = useFormik({
        initialValues: {
            viaturaId: null
        },
        validationSchema: yup.object({
            viaturaId: yup.number().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Selecionar viatura</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField InputProps={{
            endAdornment: <React.Fragment>{loading ? <CircularProgress color='inherit' size={20}/> : null}</React.Fragment>
        }} label='Viatura *' name='viaturaId' defaultValue={form.values?.viaturaId} onChange={form.handleChange} onBlur={form.handleBlur} fullWidth error={form.touched.viaturaId && Boolean(form.errors.viaturaId)} helperText={form.touched.viaturaId && form.errors.viaturaId} select>
                <MenuItem value={undefined} disabled></MenuItem>
                {viaturas &&
            viaturas.map(x => (<MenuItem value={x.id} key={x.id}>
                      {x.matricula} ({x.marca} {x.modelo})
                    </MenuItem>))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            form.handleSubmit();
        }} disabled={!form.isValid || !form.dirty || form.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogViatura;
